// Mobile navigation
jQuery(document).ready(function ($) {
  
  //  Navigation on mobile on/off
  var menuButton = document.querySelector('.menu_btn')
  var menuOn = document.querySelector('body')

  if (menuButton){
    menuButton.addEventListener('click', function() {
      $(this).next().slideToggle();
      $(this).toggleClass('active');
      $(menuOn).toggleClass('active-menu');
    });
  }

  // Sub menu open on click
  $('.siteMenu .menu-item-has-children').on('click', function() {
      $(this).children().last().slideToggle();
      $(this).toggleClass('active');
  });

})